import { Injectable } from '@angular/core';
import { IReport } from '@shared/interfaces';

@Injectable({
    providedIn: 'root'
})
export class AdminReportService {
    currentItem: IReport;
    lastActiveItem: IReport;
    historyStack: IReport[] = [];

    replaceHistory(val: IReport[]) {
        const history = [];
        for (const item of this.historyStack) {
            history.push(item?.id ? this.getItem(val, item.id) : { children: val });
        }
        this.historyStack = history;
    }

    getItem(items: IReport[], id: string): IReport {
        let result: IReport;
        if (items) {
            for (const item of items) {
                if (item.id === id) {
                    result = item;
                } else if (item.children) {
                    result = this.getItem(item.children, id);
                }
                if (result) {
                    break;
                }
            }
        }
        return result;
    }

    selectItem(item: IReport) {
        if (
            ((this.currentItem?.id && !this.historyStack.some(e => e?.id === this.currentItem?.id)) ||
                !this.currentItem?.id) &&
            (item.children || !item.modifiedAt)
        ) {
            this.historyStack.push(this.currentItem);
            this.currentItem = item;
            this.lastActiveItem = item;
        }
    }

    goBack(): IReport {
        return (this.currentItem = this.lastActiveItem = this.historyStack.pop());
    }

    reset() {
        this.currentItem = this.lastActiveItem = null;
        this.historyStack = [];
    }

    goToFirstView() {
        this.lastActiveItem = null;
        this.currentItem = this.historyStack[0];
        this.historyStack = [];
    }
}
